import { render, staticRenderFns } from "./greenCategories.vue?vue&type=template&id=9a4e208e&scoped=true"
import script from "./greenCategories.vue?vue&type=script&lang=js"
export * from "./greenCategories.vue?vue&type=script&lang=js"
import style0 from "./greenCategories.vue?vue&type=style&index=0&id=9a4e208e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e208e",
  null
  
)

export default component.exports